module.exports = __webpack_public_path__ + "d119180bab796c5e702d1e099d4a7d7a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/crown-beaded.png
// module id = 2789
// module chunks = 0